import * as yup from "yup";
import { locationFieldsSchema } from "../utils/locationFieldsValidation";

export const adminDetailSchema = yup.object().shape({
  onsiteRemote: yup.string().notRequired(),

  multiSponsor: yup.boolean().notRequired(),
  capaNeeded: yup.boolean().notRequired(),
  additionalDetails: yup.string().notRequired(),
  auditors: yup.object(),
  requestDate: yup
    .object({
      startDate: yup.string().nullable(),
      endDate: yup.string().nullable(),
    })
    .nullable()
    .notRequired(),
  requestedDraftDateChangeReason: yup.string().notRequired(),
  planningMeetingDate: yup.object({
    startDate: yup.date().nullable(),
  }).nullable(),
  firstAssessmentDate: yup.object({
    startDate: yup.date().nullable(),
  }).nullable(),
  agreedDraftDate: yup.object({
    startDate: yup.date().nullable(),
  }).nullable(),
  introEmailDate: yup.object({
    startDate: yup.date().nullable(),
  }).nullable(),
  introMeetingDate: yup.object({
    startDate: yup.date().nullable(),
  }).nullable(),
  assessmentDuration: yup.object({
    startDate: yup.date().nullable(),
  }).nullable(),
  assessmentCompletionDate: yup.object({
    startDate: yup.date().nullable(),
  }).nullable(),
  firstDraftUplaodedDate: yup.object({
    startDate: yup.date().nullable(),
  }).nullable(),

  firstDraftDelieveredSponsorDate: yup.object({
    startDate: yup.date().nullable(),
  }).nullable(),
  draftReviewDate: yup.object({
    startDate: yup.date().nullable(),
  }).nullable(),
  draftDelieveredToVendorDate: yup.object({
    startDate: yup.date().nullable(),
  }).nullable(),
  FinalReportDate: yup.object({
    startDate: yup.date().nullable(),
  }).nullable(),
  capaDelieveredToSponsorDate: yup.object({
    startDate: yup.date().nullable(),
  }).nullable(),
  firstDraftDeliveredByAuditorDate: yup
    .object({
      startDate: yup.date().nullable(),
    })
    .nullable(),
  finalDraftDeliveredByAuditorDate: yup
    .object({
      startDate: yup.date().nullable(),
    })
    .nullable(),
  observationResponseReceivedDate: yup
    .object({
      startDate: yup.date().nullable(),
    })
    .nullable(),
  observationReportCompletedDate: yup
    .object({
      startDate: yup.date().nullable(),
    })
    .nullable(),
  publishedToLibraryDate: yup
    .object({
      startDate: yup.date().nullable(),
    })
    .nullable(),
  introMeetingNotRequired: yup.boolean().notRequired(),
  diligentNotes: yup.string().notRequired(),

  providerName: yup.string().notRequired(),
  providerEmail: yup.string().email().notRequired(),
  providerPhone: yup
    .number()
    .transform((value, originalValue) => {
      // Convert empty string to null
      return originalValue === "" ? null : value;
    })
    .typeError("Phone number must be a valid number")
    .positive("Phone number must be positive")
    .integer("Phone number must not contain decimals")
    .min(1000000000, "Phone number must be at least 10 digits")
    .max(999999999999999, "Phone number must be at most 15 digits")
    .nullable() // Allows the value to be null
    .notRequired(), // Makes the field optional
  // Location optional as a whole; if any field is set, all visible fields are required
  ...locationFieldsSchema("provider", { mode: "allOrNothing" }),
  sponsors: yup.array().of(
    yup.object().shape({
      sponsorName: yup.string().required("Sponsor Name is required"),
      sponsorEmail: yup
        .string()
        .email("Invalid email format")
        .required("Sponsor Email is required"),
      sponsorPhone: yup
        .number()
        .transform((value, originalValue) => {
          // Convert empty string to null
          return originalValue === "" ? null : value;
        })
        .typeError("Phone number must be a valid number")
        .positive("Phone number must be positive")
        .integer("Phone number must not contain decimals")
        .min(1000000000, "Phone number must be at least 10 digits")
        .max(999999999999999, "Phone number must be at most 15 digits")
        .nullable() // Allows null values (empty)
        .notRequired(), // Makes the field optional
    })
  ),
});
